import { BaseReplaceContentComponent } from "../../BaseReplaceContentComponent";

export abstract class BaseAsideMenuComponent extends BaseReplaceContentComponent {
  private _onPageChange!: (page: string) => void;

  constructor() {
    super(document.getElementById("sideBarNav")!);
  }

  public setOnPageChange(onPageChange: (page: string) => void) {
    this._onPageChange = onPageChange;
  }

  //

  protected abstract afterInit(parent: HTMLElement): void;

  protected onPageChange(page: string) {
    this._onPageChange(page);
  }

  /**
   * Marca en el menú la opción de la ruta que se acaba de abrir. La llama `AppComponent` en cada navegación, venga del
   * menú o de una página; cada menú la implementa con sus rutas. Por defecto no hace nada.
   */
  public marcarRuta(_route: string): void {}
  /*
  {
    parent.querySelectorAll<HTMLLinkElement>("a").forEach((link) => {
      if (link.classList.contains("mod-dataag")) {
        this._initDropdown(link);
      } //
      else {
        this._initLink(link);
      }
    });
  }
  */

}
